export const PAGE = document.getElementById('main');
